// Units of the stock and sale quantities of a product (same codes as the Core
// STOCK_UNITS). null = piece. Quantities keep 3 decimals: 250 g of a product
// managed in kg is 0.25.
export const STOCK_UNITS = ['pc', 'kg', 'g', 'l', 'cl', 'ml', 'm', 'cm', 'm2'];

// Piece: nothing is shown after the quantity
export function isPieceUnit(unit?: string | null): boolean {
  return !unit || unit === 'pc' || !STOCK_UNITS.includes(unit);
}

// International symbol of a unit, '' for a piece
export function stockUnitSymbol(unit?: string | null): string {
  if (isPieceUnit(unit)) return '';
  if (unit === 'l') return 'L';
  if (unit === 'm2') return 'm²';
  return unit;
}
